import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import isEqual from 'react-fast-compare';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

type Props = {
    baseUrl: string;
    catalogsTodayCount: number;
    page: number;
};

const AuctionCalendarPageHeaderMeta = ({ baseUrl, catalogsTodayCount = 1, page }) => {
    const { formatMessage } = useIntl();

    let title = formatMessage({ id: 'auction_calendar_title' });

    if (page > 1) {
        title += formatMessage({ id: 'page_number_and_title' }, { page });
    }

    title = useAddNotificationCountToTitle(title);

    const description = formatMessage({ id: 'auction_calendar_description' }, { count: catalogsTodayCount });
    const canonical = `${baseUrl}/catalog/search/`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default React.memo<Props>(AuctionCalendarPageHeaderMeta, isEqual);
